import { getGlobalHeadersAsObject } from "../global-headers";

export type PersonEvent = {
	id: number;
	model: "Vote" | "SentInvitation" | "Connection";
	name: string;
	description: string;
	icon: string;
	timestamp: number;
	user: string;
	/** Real LinkedIn "connected on" date — Connection events only. */
	connected?: string | null;
	/** Enqueue date from the queue snapshot — SentInvitation events only. */
	enqueued?: string | null;
};

export const getPersonEventsById = (id: number): Promise<PersonEvent[]> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getPersonEducationById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/persons/${id}/events/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
